// Centralized mock data for Agency pages
// Usage example:
// import { clients, campaigns, analyticsDashboard, clientReports } from './mockData';

// Simple ID generator
let __id = 1;
const nextId = () => __id++;

export const clients = [
  { id: nextId(), name: 'City Fleet Services', contact: 'Sarah Johnson', email: 'sarah@cityfleet.com', status: 'active' },
  { id: nextId(), name: 'Metro Logistics', contact: 'Tom Davis', email: 'tom@metrolog.com', status: 'active' },
  { id: nextId(), name: 'Northwind Traders', contact: 'Nancy Fuller', email: 'nancy@northwind.com', status: 'inactive' },
];

export const vehicles = [
  { id: nextId(), plate: 'ABC-123', make: 'Ford', model: 'Transit', year: 2021, status: 'in_service', mileage: 42010 },
  { id: nextId(), plate: 'XYZ-789', make: 'Mercedes', model: 'Sprinter', year: 2022, status: 'in_service', mileage: 19822 },
  { id: nextId(), plate: 'DEF-456', make: 'Chevrolet', model: 'Express', year: 2020, status: 'maintenance', mileage: 76543 },
  { id: nextId(), plate: 'GHJ-234', make: 'Ram', model: 'ProMaster', year: 2023, status: 'out_of_service', mileage: 8523 },
];

export const drivers = [
  { id: nextId(), name: 'Alice Thompson', status: 'active', phone: '+1 (415) 555-0101', vehiclePlate: 'XYZ-789' },
  { id: nextId(), name: 'Brian Lee', status: 'off_duty', phone: '+1 (415) 555-0102', vehiclePlate: 'ABC-123' },
  { id: nextId(), name: 'Carla Gomez', status: 'active', phone: '+1 (415) 555-0103', vehiclePlate: 'DEF-456' },
  { id: nextId(), name: 'David Kim', status: 'maintenance', phone: '+1 (415) 555-0104', vehiclePlate: 'GHJ-234' },
];

export const workspaces = [
  { id: nextId(), name: 'Default Workspace', owner: 'Sarah Johnson', createdAt: '2025-04-02', status: 'active' },
  { id: nextId(), name: 'Q3 Performance', owner: 'Ops Team', createdAt: '2025-06-15', status: 'active' },
];

export const campaigns = [
  { id: nextId(), name: 'City Outreach', clientId: clients[0].id, status: 'running', budget: 12000, startDate: '2025-07-01', endDate: '2025-09-30' },
  { id: nextId(), name: 'Holiday Prep', clientId: clients[1].id, status: 'draft', budget: 8000, startDate: '2025-10-15', endDate: '2026-01-15' },
  { id: nextId(), name: 'Retention Boost', clientId: clients[2].id, status: 'pending_approval', budget: 5000, startDate: '2025-08-01', endDate: '2025-10-31' },
];

export const approvalsQueue = [
  { id: nextId(), campaignId: campaigns[2].id, submittedBy: 'Brian Lee', date: '2025-08-18', status: 'pending' },
];

export const mediaLibrary = [
  { id: nextId(), type: 'image', name: 'van-exterior.jpg', tags: ['vehicle', 'brand'], sizeKB: 340 },
  { id: nextId(), type: 'video', name: 'route-demo.mp4', tags: ['promo'], sizeKB: 15200 },
  { id: nextId(), type: 'image', name: 'city-skyline.png', tags: ['city', 'cover'], sizeKB: 820 },
];

export const clientMedia = [
  { id: nextId(), clientId: clients[0].id, type: 'image', name: 'logo-cityfleet.svg', tags: ['logo'] },
  { id: nextId(), clientId: clients[1].id, type: 'image', name: 'metro-banner.png', tags: ['banner'] },
];

export const templates = [
  { id: nextId(), name: 'Standard Promo', description: '50% off banner', variables: ['headline', 'cta'] },
  { id: nextId(), name: 'Location Target', description: 'Geo radius ad', variables: ['radius', 'city'] },
];

export const audiences = {
  agency: [
    { id: nextId(), name: 'Frequent Downtown Visitors', size: 120000, type: 'behavioral' },
    { id: nextId(), name: 'Commuters 7-10AM', size: 80000, type: 'temporal' },
  ],
  clients: [
    { id: nextId(), clientId: clients[0].id, name: 'City Fleet Leads', size: 5400, type: 'crm' },
    { id: nextId(), clientId: clients[1].id, name: 'Metro Repeat Buyers', size: 2100, type: 'crm' },
  ],
};

export const budgetAllocation = [
  { id: nextId(), clientId: clients[0].id, campaignId: campaigns[0].id, monthly: 4000 },
  { id: nextId(), clientId: clients[1].id, campaignId: campaigns[1].id, monthly: 3000 },
];

export const calendar = [
  { id: nextId(), title: 'City Outreach Flight 1', date: '2025-09-05', campaignId: campaigns[0].id },
  { id: nextId(), title: 'Retention Boost QA', date: '2025-09-12', campaignId: campaigns[2].id },
];

export const analyticsDashboard = {
  impressions: 2850000,
  clicks: 182340,
  conversions: 12435,
  spend: 45780,
  byClient: clients.map((c, idx) => ({ clientId: c.id, name: c.name, spend: [23000, 15000, 7780][idx] || 2500 })),
};

export const clientReports = [
  { id: nextId(), clientId: clients[0].id, client: clients[0].name, period: '2025-07', impressions: 920000, clicks: 60500, conversions: 4100, spend: 23000, status: 'active' },
  { id: nextId(), clientId: clients[1].id, client: clients[1].name, period: '2025-07', impressions: 610000, clicks: 40210, conversions: 2820, spend: 15000, status: 'active' },
  { id: nextId(), clientId: clients[2].id, client: clients[2].name, period: '2025-07', impressions: 310000, clicks: 21630, conversions: 1515, spend: 7780, status: 'inactive' },
];

export const exportJobs = [
  { id: nextId(), name: 'Q2 Summary', createdAt: '2025-07-10', status: 'completed' },
  { id: nextId(), name: 'All Clients CSV', createdAt: '2025-08-02', status: 'running' },
];

export const teamMembers = [
  { id: nextId(), name: 'Sarah Johnson', role: 'Manager', email: 'sarah@agency.com', status: 'active' },
  { id: nextId(), name: 'Brian Lee', role: 'Analyst', email: 'brian@agency.com', status: 'active' },
  { id: nextId(), name: 'Carla Gomez', role: 'Creator', email: 'carla@agency.com', status: 'invited' },
];

export const roles = [
  { id: nextId(), name: 'Manager', permissions: ['campaigns:approve', 'billing:view', 'users:invite'] },
  { id: nextId(), name: 'Analyst', permissions: ['analytics:view'] },
  { id: nextId(), name: 'Creator', permissions: ['media:upload', 'campaigns:create'] },
];

export const integrations = {
  facebook: { connected: true, account: 'fb-12345', lastSync: '2025-08-20T10:00:00Z' },
  googleAds: { connected: false, account: null, lastSync: null },
  tools: [
    { id: nextId(), name: 'Zapier', connected: true },
    { id: nextId(), name: 'Slack', connected: true },
  ],
};

export const billing = {
  subscription: { plan: 'Pro', status: 'active', renewsOn: '2026-01-01', seats: 10, pricePerMonth: 299 },
  clients: clients.map((c, i) => ({ clientId: c.id, name: c.name, currentPlan: ['Basic', 'Pro', 'Pro'][i], balanceDue: [0, 120, 0][i] })),
  history: [
    { id: nextId(), date: '2025-08-01', amount: 299, status: 'paid', method: 'Visa **** 4242' },
    { id: nextId(), date: '2025-07-01', amount: 299, status: 'paid', method: 'Visa **** 4242' },
  ],
};

export const notifications = [
  { id: nextId(), title: 'Campaign Approved', body: 'Retention Boost is now approved.', time: '2h', read: false },
  { id: nextId(), title: 'New Client Invite Accepted', body: 'Carla joined the workspace.', time: '6h', read: true },
];

export const supportTickets = [
  { id: nextId(), subject: 'Billing discrepancy', status: 'open', createdAt: '2025-08-19', lastUpdate: '2025-08-20' },
  { id: nextId(), subject: 'Facebook sync issue', status: 'resolved', createdAt: '2025-08-15', lastUpdate: '2025-08-16' },
];

export const chatMessages = [
  { id: nextId(), from: 'Sarah', message: 'Morning! Any blockers today?', time: '09:02' },
  { id: nextId(), from: 'Brian', message: 'All good, running reports now.', time: '09:05' },
];

export const settings = {
  profile: { name: 'City Fleet Services', contact: 'Sarah Johnson', email: 'sarah@cityfleet.com', phone: '+1 (415) 555-0110' },
  security: { twoFA: true, lastPasswordChange: '2025-07-22', allowedIPs: ['192.168.1.0/24'] },
};

export const alerts = [
  { id: nextId(), vehicle: 'ABC-123', type: 'Maintenance Due', time: '2 hours ago', status: 'Pending' },
  { id: nextId(), vehicle: 'XYZ-789', type: 'Speeding Alert', time: '5 hours ago', status: 'Acknowledged' },
  { id: nextId(), vehicle: 'DEF-456', type: 'Check Engine', time: '1 day ago', status: 'In Progress' },
];
